import BarraFiltroInputEditar from "./components/BarraFiltroInput/BarraFiltroInput";
import {
  BarraFiltrosBody,
  BarraFiltrosBtn,
  BarraFiltrosContainer,
  BarraFiltrosFooter,
  BarraFiltrosHeader,
} from "./localStyle";
import { useContext, useEffect, useState } from "react";
import FiltroCascada from "./components/FiltroCascada/FiltroCascada";
import camelize from "global/utils/camelize";
import { dias, horario } from "./dtoBarraFiltro";
import { GlobalContext } from "global/context/Provider";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import DatePicker from "_+_Portal/components/Genericos/DatePicker/DatePicker";
import CalendarIcon from "./assets/CalendarIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

const BarraFiltros = ({
  onClickVolver,
  showFiltros,
  onChangeFiltro,
  onChangeFecha,
  onClickFiltros,
}) => {
  //#region --------- context ---------------
  const { modalDispatch, toasterDispatch } = useContext(GlobalContext);
  const { turnosDisponiblesState } = useContext(PortalContext);
  const { rutaState, centroState } = useContext(AutocheckContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------

  const isLaboratorio = rutaState.ruta.data.seleccionRuta === "laboratorio";
  // const isKinesio = rutaState.ruta.data.isKinesio;

  const { data, turnos } = turnosDisponiblesState.turnosDisponibles.data;
  const turnosDisponibles = data ? data : turnos;
  let nombresCentros = [];
  let nombresEspecialistas = [];
  const [dtoFiltros, setDtoFiltros] = useState({
    centro: isLaboratorio ? centroState.centrosLaboSeleccionados : ["Todos"],
    diaSemanal: ["Todos"],
    horario: ["Todos"],
    especialista: ["Todos"],
  });

  const [fechaSeleccionada, setFechaSeleccionada] =
    useState(obtenerFechaActual());
  const [prevFlag, setPrevFlag] = useState(false);

  //elimino centro duplicados
  if (turnosDisponibles) {
    nombresCentros = [
      ...new Set(turnosDisponibles?.map((item) => item.centro)),
    ]?.map((nombre) => ({
      nombre: camelize(nombre),
    }));

    nombresEspecialistas = [
      ...new Set(turnosDisponibles?.map((item) => item.medico)),
    ]
      ?.map((nombre) => ({
        nombre: camelize(nombre),
      }))
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
  }

  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const dismiss = () => {
    hideModal()(modalDispatch);
  };

  const onClickCascada = (items, titulo, onClickFunction, values) => {
    showModal(
      <FiltroCascada
        onClickAplicar={(items) => onClickFunction(items)}
        onClickCerrar={dismiss}
        elementos={items}
        values={values}
      />,
      titulo,
      dismiss,
      false,
      {},
      "centro",
      true,
    )(modalDispatch);
  };

  function obtenerFechaActual() {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes =
      hoy.getMonth() + 1 >= 10 ? hoy.getMonth() + 1 : `0${hoy.getMonth() + 1}`;
    const día = hoy.getDate() >= 10 ? hoy.getDate() : `0${hoy.getDate()}`;
    return `${año} ${mes} ${día}`;
  }

  function obtenerFechaFutura(dias) {
    const hoy = new Date();
    const futuro = new Date(hoy.getTime() + dias * 24 * 60 * 60 * 1000);

    const año = futuro.getFullYear();
    const mes =
      futuro.getMonth() + 1 >= 10
        ? futuro.getMonth() + 1
        : `0${futuro.getMonth() + 1}`;
    const día =
      futuro.getDate() >= 10 ? futuro.getDate() : `0${futuro.getDate()}`;

    return `${año} ${mes} ${día}`;
  }

  const onClickDatePicker = () => {
    showModal(
      <DatePicker
        fechaInicial={obtenerFechaActual()}
        fechaFinal={obtenerFechaFutura(90)}
        selectedFecha={fechaSeleccionada.replace("-", " ")}
        onChange={onChangeDatePicker}
        onClickCerrar={dismiss}
        footerString={"Búsqueda a partir de:"}
      />,
      "Fecha desde",
      dismiss,
      false,
      {},
      "centro",
      true,
    )(modalDispatch);
  };

  function formatFechaBarras(fecha) {
    const fechaConBarras = fecha.replace(/[-\s]/g, "/");
    if (fechaConBarras.includes("/")) {
      const partes = fechaConBarras.split("/");
      return partes[2] + "/" + partes[1] + "/" + partes[0];
    } else {
      const partes = fechaConBarras.split(" ");
      return partes[2] + "/" + partes[1] + "/" + partes[0];
    }
  }

  const onChangeDatePicker = (fechaSeleccionada) => {
    onChangeFecha(fechaSeleccionada, dtoFiltros);
    setFechaSeleccionada(fechaSeleccionada);
    onClickFiltros();
  };

  const onChangeCentro = (arrayCentro) => {
    if (arrayCentro.length > 0) {
      setPrevFlag(true);
      setDtoFiltros({ ...dtoFiltros, centro: arrayCentro });
      dismiss();
    } else {
      showToaster(
        {
          texto: "Debe seleccionar al menos un Centro Médico",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
    onClickFiltros();
  };
  const onChangeDiaSemanal = (arrayDias) => {
    if (arrayDias.length > 0) {
      setPrevFlag(true);
      setDtoFiltros({ ...dtoFiltros, diaSemanal: arrayDias });
      dismiss();
    } else {
      showToaster(
        {
          texto: "Debe seleccionar al menos un día de la semana",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
    onClickFiltros();
  };
  const onChangeHorario = (arrayHorario) => {
    if (arrayHorario.length > 0) {
      setPrevFlag(true);
      setDtoFiltros({ ...dtoFiltros, horario: arrayHorario });
      dismiss();
    } else {
      showToaster(
        {
          texto: "Debe seleccionar al menos un rango de horario",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
    onClickFiltros();
  };
  const onChangeEspecialistas = (arrayEspecialistas) => {
    if (arrayEspecialistas.length > 0) {
      setPrevFlag(true);
      setDtoFiltros({ ...dtoFiltros, especialista: arrayEspecialistas });
      dismiss();
    } else {
      showToaster(
        {
          texto: "Debe seleccionar al menos un especialista",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
    onClickFiltros();
  };

  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    if (prevFlag) {
      onChangeFiltro(dtoFiltros);
    }
  }, [dtoFiltros, prevFlag]);
  //#endregion  -------- useEffect ---------------

  return (
    <BarraFiltrosContainer showFiltros={showFiltros}>
      <BarraFiltrosHeader>
        <span>Filtros</span>
      </BarraFiltrosHeader>
      <BarraFiltrosBody>
        <BarraFiltroInputEditar
          icon={<CalendarIcon />}
          title={"Fecha desde"}
          value={formatFechaBarras(fechaSeleccionada)}
          onClick={() => onClickDatePicker()}
        />

        <>
          <BarraFiltroInputEditar
            title={"Centro"}
            value={dtoFiltros.centro?.join(", ")}
            onClick={() =>
              onClickCascada(
                nombresCentros,
                "Centro",
                (items) => onChangeCentro(items),
                dtoFiltros.centro,
              )
            }
          />
          <BarraFiltroInputEditar
            title={"Día de semana"}
            value={dtoFiltros.diaSemanal?.join(", ")}
            onClick={() =>
              onClickCascada(
                dias,
                "Día semanal",
                (items) => onChangeDiaSemanal(items),
                dtoFiltros.diaSemanal,
              )
            }
          />
          <BarraFiltroInputEditar
            title={"Horario"}
            value={dtoFiltros.horario?.join(", ")}
            onClick={() =>
              onClickCascada(
                horario,
                "Horario",
                (items) => onChangeHorario(items),
                dtoFiltros.horario,
              )
            }
          />
          {!isLaboratorio && (
            <BarraFiltroInputEditar
              title={"Especialista"}
              value={dtoFiltros.especialista.join(", ")}
              onClick={() =>
                onClickCascada(
                  nombresEspecialistas,
                  "Especialistas",
                  (items) => onChangeEspecialistas(items),
                  dtoFiltros.especialista,
                )
              }
            />
          )}
        </>
      </BarraFiltrosBody>
      <BarraFiltrosFooter>
        <BarraFiltrosBtn onClick={onClickVolver}>Volver</BarraFiltrosBtn>
      </BarraFiltrosFooter>
    </BarraFiltrosContainer>
  );
};

export default BarraFiltros;
